import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DelaStarIcon } from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5)
  },
  resourcesColumn: {
    flex: 1,
    minWidth: theme.spacing(20)
  },
  smartMatchColumn: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    minWidth: theme.spacing(12)
  },
  availabilityColumn: {
    minWidth: theme.spacing(12),
    textAlign: 'center'
  },
  delaText: {
    fontSize: theme.spacing(1.625),
    lineHeight: 1,
    color: theme.palette.Dela.darkIcon
  },
  spacerColumn: {
    width: theme.spacing(10.5)
  }
}));

export const useDelaStarIconStyles = makeStyles(theme => ({
  root: {
    fill: theme.palette.Dela.darkIcon,
    fontSize: theme.spacing(2)
  }
}));

export const ResourceMatchListHeader = () => {
  const classes = useStyles();
  const delaStarIconClasses = useDelaStarIconStyles();
  const { formatMessage } = useIntl();

  return (
    <div data-qe-id="ResourceMatchListHeader" className={classes.root}>
      <div className={classes.resourcesColumn}>
        <Typography variant="subtitle2">
          {formatMessage({
            id: 'resourceMatchPopover.resources'
          })}
        </Typography>
      </div>
      <div className={classes.smartMatchColumn}>
        <Typography variant="subtitle2">
          {formatMessage({
            id: 'resourceMatchPopover.smartMatch'
          })}
        </Typography>
        <DelaStarIcon classes={delaStarIconClasses} />
      </div>
      <div className={classes.availabilityColumn}>
        <Typography variant="subtitle2">
          {formatMessage({
            id: 'resourceMatchPopover.availability'
          })}
        </Typography>
      </div>
      <div className={classes.spacerColumn}></div>
    </div>
  );
};

export default ResourceMatchListHeader;
